import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { InstanceManagerState, Instance, StandAloneModal } from './types';
import { RootState } from 'store';

const initialState: InstanceManagerState = {
    showGridSpinner: false,
    gridSource: {
        data: [],
        total: 0,
        filter: {
            searchTerm: null
        },
    },
    standAloneModal: {
        visible: false,
        locked: false,
        source: {
            projectId: null,
            projects: [],
            instanceId: '',
        }
    }
};

export const instanceManagerSlice = createSlice({
    name: 'InstanceManager',
    initialState,
    reducers: {
        setGridSource(state, action: PayloadAction<{ data: Instance[]; total: number }>) {
            state.gridSource.data = action.payload.data;
        },
        changeSearchTerm(state, action: PayloadAction<string | null>) {
            state.gridSource.filter.searchTerm = action.payload;
        },
        toggleGridSpinner(state, action: PayloadAction<boolean>) {
            state.showGridSpinner = action.payload;
        },
        standAloneModalOpen(state, action: PayloadAction<StandAloneModal['source']>) {
            state.standAloneModal = {
                visible: true,
                locked: false,
                source: action.payload
            }
        },
        standAloneModalClose(state) {
            state.standAloneModal = initialState.standAloneModal;
        },
        toggleStandAloneModalSpinner(state, action: PayloadAction<boolean>) {
            state.standAloneModal.locked = action.payload;
        },
        setSelectedProject(state, action: PayloadAction<number>) {
            state.standAloneModal.source.projectId = action.payload;
        },
        reset(state) {
            state = initialState;
        }
    },
});

export const selectFilteredInstances = createSelector([
    (state: RootState) => state.instanceMgrSlice.gridSource.data,
    (state: RootState) => state.instanceMgrSlice.gridSource.filter.searchTerm?.toLowerCase() || '',
], (data, term) => {
    if (!term) return data;

    return data.filter((d) =>
        (d.instanceId?.toLowerCase().includes(term) ?? false) ||
        (d.instanceName?.toLowerCase().includes(term) ?? false) ||
        (d.projectName?.toLowerCase().includes(term) ?? false) ||
        (d.taskName?.toLowerCase().includes(term) ?? false)
    );
});

export const actions = instanceManagerSlice.actions;
export default instanceManagerSlice.reducer;